import { Chip, Popover, styled } from '@mui/material';

export const metaTagColor = '#414c52';
export const metaTagBackgroundColor = 'rgba(207, 216, 220, 0.4)';
export const metaTagColorDarkMode = 'rgba(256, 256, 256, 0.5)';
export const metaTagBackgroundDarkMode = '#535556';

export const ChipLabelWrapper = styled('div')`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
`;

export const ChipWrapper = styled('div')`
  padding: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 400px;
  background-color: ${({ theme: { palette } }) => palette.background.default};
`;

export const ChipStyled = styled(Chip)(({ theme }) => ({
  margin: theme.spacing(1),
  cursor: 'default',
  borderWidth: 0,
  color: theme.palette.text.primary,
  fontWeight: 'bold',
  backgroundColor: theme.palette.mode === 'dark' ? metaTagBackgroundDarkMode : metaTagBackgroundColor,
}));
export const ChipInPopover = styled(Chip)(({ theme }) => ({
  borderColor: theme.palette.text.secondary,
  color: theme.palette.text.primary,
}));
export const PopoverStyled = styled(Popover)(({ theme }) => ({
  '.MuiPopover-paper': {
    background: theme.palette.background.paper,
  },
}));
